/**
 * GWP multi-product gift carousel - shown in the push-cart when a tier
 * offers more than one gift product. Native horizontal scroll inside the
 * theme's scroll-carousel (allow-drag, for mouse dragging on desktop),
 * matching recently-viewed-products' "cart-cards" view exactly; tile
 * actions call straight into the same add paths every other GWP entry
 * point uses.
 */
class GiftWithPurchaseCarousel extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.slide.elements.forEach(slide => {
      const addButton = slide.querySelector('[data-gift-with-purchase-el="carousel_add"]')
      if (addButton) {
        this.listeners.add(addButton, 'click', () => this.handleDirectAdd(addButton))
      }

      const selectShadeButton = slide.querySelector('[data-gift-with-purchase-el="carousel_select_shade"]')
      if (selectShadeButton) {
        this.listeners.add(selectShadeButton, 'click', () => this.handleSelectShade(selectShadeButton))
      }
    })
  }

  handleDirectAdd (button) {
    window.BAO.GiftWithPurchase.handlePromptClick({
      campaignId: button.dataset.campaignId,
      tierIndex: parseInt(button.dataset.tierIndex, 10),
      variantId: button.dataset.variantId,
      quantity: parseInt(button.dataset.quantity, 10) || 1,
    })
  }

  handleSelectShade (button) {
    const drawer = document.querySelector('drawer-gift-with-purchase')

    if (!drawer) {
      console.warn('GWP: No drawer-gift-with-purchase element found')
      return
    }

    drawer.openForTier({
      campaignId: button.dataset.campaignId,
      tierIndex: parseInt(button.dataset.tierIndex, 10),
      productUrl: button.dataset.productUrl,
      variantIds: button.dataset.variantIds,
      quantity: parseInt(button.dataset.quantity, 10) || 1,
    })
  }
}

if (!customElements.get('gift-with-purchase-carousel')) {
  customElements.define('gift-with-purchase-carousel', GiftWithPurchaseCarousel)
}
